import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../store';
import { Injectable } from '@angular/core';
import {AppAction, AppActionState, IAppAction} from './interfaces/IAppState';
import {Reservation} from '../api/model/reservation/reservation.model';
import {ReservationStayPreferences} from '../api/model/reservation/stay-preferences/reservation-stay-preferences.model';
import {AccountStayPreferences} from '../api/model/user/stay-preferences/stay-preference.model';
import {EarningsEstimate} from '../api/model/reservation/points-estimate/earnings-estimate.model';
import {ReservationChangeType} from '../api/model/reservation/change/reservation-change.model';
import {Hotel} from '../api/model/hotel/hotel.model';
import {User} from '../api/model/user/user.model';
import {FeatureFlags} from '../api/model/featureflags/feature-flags.model';
import {IMessage} from '../api/interfaces/Messages/IMessage';
import {IAppConfig} from './interfaces/IAppConfig';
import {IResDirectNumber} from '../api/interfaces/ResDirect/IResDirectNumber';
import {Translation} from '../api/interfaces/Translation/ITranslation';

@Injectable()
export class Actions {

  constructor(
    private ngRedux: NgRedux<IAppState>,
  ) {}

  dispatchAddTranslation(actionType: AppAction, value: Translation) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      value
    });
  }

  dispatchAddFeatureFlags(actionType: AppAction, value: FeatureFlags = null, error = null) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      featureFlags: value,
      error: error
    });
  }

  dispatchAcceptTerms(actionType: AppAction, value: boolean) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      value
    });
  }

  dispatchSaveToProfile(actionType: AppAction, value: boolean) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      value
    });
  }

  dispatchMe(actionType: AppAction, value: any) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      value
    });
  }

  dispatchResDirect(actionType: AppAction, value: IResDirectNumber) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      value
    });
  }

  dispatchAppConfig(actionType: AppAction, value: IAppConfig) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      value
    });
  }

  dispatchAddMessage(actionType: AppAction, value: IMessage) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      value
    });
  }

  dispatchReservationAction(actionType: AppAction, state: AppActionState , value: Reservation = null, error = null) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      state: state,
      reservation: value,
      error: error
    });
  }

  dispatchHotelAction(actionType: AppAction, state: AppActionState , value: Hotel = null, error = null) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      state: state,
      hotel: value,
      error: error
    });
  }

  dispatchMemberAction(actionType: AppAction, state: AppActionState , value: User = null, error = null) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      state: state,
      member: value,
      error: error
    });
  }

  dispatchAvailableReservationAction(actionType: AppAction, state: AppActionState , value: Reservation = null, error = null) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      state: state,
      availableReservation: value,
      error: error
    });
  }

  dispatchStayPreferencesAction(actionType: AppAction, state: AppActionState , value: ReservationStayPreferences = null, error = null) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      state: state,
      stayPreferences: value,
      error: error
    });
  }

  dispatchAccountStayPreferencesAction(actionType: AppAction, state: AppActionState , value: AccountStayPreferences = null, error = null) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      state: state,
      stayPreferences: value,
      error: error
    });
  }

  dispatchReservationChangesAction(actionType: AppAction, state: AppActionState , value: Map<ReservationChangeType, any>, error = null) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      state: state,
      reservationChanges: value,
      error: error
    });
  }

  dispatchPointsEstimateAction(actionType: AppAction, state: AppActionState, value: EarningsEstimate = null, error = null) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      state: state,
      earningsEstimate: value,
      error: error
    });
  }

  dispatchRateDetailsAction(actionType: AppAction, value: any) {
    return this.dispatcher(<IAppAction>{
      type: actionType,
      value
    });
  }

  dispatcher(action: IAppAction) {
    return this.ngRedux.dispatch(action);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/store/actions.ts